import { render, staticRenderFns } from "./ListRegistrationsCount.vue?vue&type=template&id=0535c00c&scoped=true&"
import script from "./ListRegistrationsCount.vue?vue&type=script&lang=js&"
export * from "./ListRegistrationsCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0535c00c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
